module.exports = __webpack_public_path__ + "img/Monte_Kope_32.4eceedd4.jpg";